import { render, staticRenderFns } from "./homeActivity.vue?vue&type=template&id=64217f9c&scoped=true&"
import script from "./homeActivity.vue?vue&type=script&lang=js&"
export * from "./homeActivity.vue?vue&type=script&lang=js&"
import style0 from "./homeActivity.vue?vue&type=style&index=0&id=64217f9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64217f9c",
  null
  
)

export default component.exports